import { User, JwtConfigs } from "@/store/authentication/types";
import { PasswordReset, SSODtoIn, AzureAdConfig } from "@/services/security/types";
import { AzureAdStatus } from "@/store/types";
import { msalConfig, loginRequest } from "./azureConfigs";
import api from "../api";
import store from "@/store/index";
import * as Msal from "msal";

export async function getAzureAdConfig(): Promise<AzureAdConfig> {
    return new Promise((resolve, reject) => {
        api.get("/account/azureAdConfig").then(
            response => {
                resolve(response.data);
            },
            error => {
                reject(error);
            }
        );
    });
}

export async function getAzureAdStatus(): Promise<AzureAdStatus> {
    return new Promise((resolve, reject) => {
        api.get("/account/azureAdStatus").then(
            response => {
                resolve(response.data);
            },
            error => {
                reject(error);
            }
        );
    });
}

export async function login(user: User): Promise<any> {
    return new Promise((resolve, reject) => {
        api.post("/account/login/", user).then(
            response => {
                resolve(response);
            },
            error => {
                reject(error);
            }
        );
    });
}

export async function hasUserConsented(id: string): Promise<boolean> {
    return new Promise((resolve, reject) => {
        api.get(`/account/hasConsented/${id}`).then(
            response => {
                resolve(response.data);
            },
            error => {
                reject(error);
            }
        );
    });
}

export async function consent(): Promise<void> {
    return new Promise((resolve, reject) => {
        api.put("/account/consent/", {}).then(
            response => {
                resolve(response.data);
            },
            error => {
                reject(error);
            }
        );
    });
}

export async function adminLogin(token: string): Promise<any> {
    return new Promise((resolve, reject) => {
        api.post("/account/AdminLogin/", { token: token }).then(
            response => {
                resolve(response);
            },
            error => {
                reject(error);
            }
        );
    });
}

export async function impersonate(userId: string): Promise<any> {
    return new Promise((resolve, reject) => {
        api.post("/account/Impersonate/", { userId: userId }).then(
            response => {
                resolve(response);
            },
            error => {
                reject(error);
            }
        );
    });
}

export async function cancelImpersonation(): Promise<any> {
    return new Promise((resolve, reject) => {
        api.post("/account/CancelImpersonation/", {}).then(
            response => {
                resolve(response);
            },
            error => {
                reject(error);
            }
        );
    });
}

export async function azureLogin(): Promise<any> {
    const appSettings = await getAzureAdConfig();
    msalConfig.auth.clientId = appSettings.azureAppClientId;
    msalConfig.auth.redirectUri = window.location.origin;
    msalConfig.auth.authority = `https://login.microsoftonline.com/${appSettings.clientTenantId}`;
    const MsalObj = new Msal.UserAgentApplication(msalConfig);
    return new Promise((resolve, reject) => {
        MsalObj.loginPopup(loginRequest).then(loginResponse => {
            api.post("/account/AzureLogIn/", { token: loginResponse.idToken.rawIdToken } as SSODtoIn).then(
                response => {
                    resolve(response);
                },
                error => {
                    reject(error);
                }
            );
        }).catch(error => {
            console.log(error);
            reject(error);
        });
    });
}

export async function azureLogout() {
    const appSettings = await getAzureAdConfig();
    msalConfig.auth.clientId = appSettings.azureAppClientId;
    msalConfig.auth.redirectUri = window.location.origin;
    const MsalObj = new Msal.UserAgentApplication(msalConfig);
    MsalObj.logout();
};

export async function getToken(): Promise<any> {
    const appSettings = await getAzureAdConfig();
    msalConfig.auth.clientId = appSettings.azureAppClientId;
    msalConfig.auth.redirectUri = window.location.origin;
    const MsalObj = new Msal.UserAgentApplication(msalConfig);
    // if (myMSALObj.getAccount()) {
    //     showWelcomeMessage(myMSALObj.getAccount());
    // }
    return MsalObj.acquireTokenSilent(loginRequest)
        .then((response) => {
            console.log(response);
            if (response.accessToken) {
                console.log("access_token acquired at: " + new Date().toString());
                const accessToken = response.accessToken;
                console.log("silent");
                console.log(accessToken);
            }
        }).catch(error => {
            console.log("silent token acquisition fails. acquiring token using redirect");
            console.log(error);
            // fallback to interaction when silent call fails
            return MsalObj.acquireTokenRedirect(loginRequest);
        });
};

export function logout() {
    store.commit("authentication/authClear");
}

export async function checkIfAuthenticated(): Promise<any> {
    return new Promise((resolve, reject) => {
        api.get("/account/isAuthenticated").then(
            response => {
                resolve(response);
            },
            error => {
                reject(error);
            }
        );
    });
}

export async function resetPassword(email: string, templateName: string): Promise<PasswordReset> {
    return new Promise((resolve, reject) => {
        api.post("/account/resetPassword", { Email: email, TemplateName: templateName }).then(
            response => {
                resolve(response.data);
            },
            error => {
                reject(error);
            }
        );
    });
}

export async function createNewPassword(email: string, password: string, token: string): Promise<PasswordReset> {
    return new Promise((resolve, reject) => {
        api.post("/account/createNewPassword", { email: email, password: password, token: token }).then(
            response => {
                resolve(response.data);
            },
            error => {
                reject(error);
            }
        );
    });
}

let time = 0;
export function configAutoLogout() {
    store.commit("authentication/setAutologout", false);
    const jwtConfigs: JwtConfigs = store.getters["authentication/getJwtConfigs"];
    const notificationTimeInSeconds = jwtConfigs.jwtExpireSeconds + jwtConfigs.jwtInvalidSeconds - jwtConfigs.jwtLogoutWarningSeconds;
    resetTime();
    if (notificationTimeInSeconds > 0) {
        startAutoLogout(notificationTimeInSeconds);
    }
}

function resetTime() {
    clearTimeout(time);
}

function startAutoLogout(seconds: number) {
    time = setTimeout(logoutNotification, seconds * 1000);
}

function logoutNotification() {
    store.commit("authentication/setAutologout", true);
    resetTime();
    time = setTimeout(logout, store.getters["authentication/getJwtConfigs"].jwtLogoutWarningSeconds * 1000);
}
